import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Collapsible, OffCanvas } from 'react-components';
import Header from './Header';
import Link from '../Link/Link';
import { renderCollapsibleContent, renderHeader, renderList, renderTitle } from './menu-utils';

class MobileMenu extends PureComponent {
  state = {
    isSubMenuVisible: false,
    selectedSubMenu: this.props.selectedSubMenu || null,
  };

  closeMenu = event => {
    this.resetSubMenuState();
    this.props.onCloseMenu();
  };

  closeSubMenu = event => {
    event.preventDefault();
    this.resetSubMenuState();
  };

  handleClick = url => {
    this.props.onClick(url);
  };

  selectSubMenu = id => {
    this.setState(
      {
        isSubMenuVisible: true,
        selectedSubMenu: id,
      },
      () => {
        this.props.onSelectSubMenu(id);
      },
    );
  };

  resetSubMenuState = () => {
    this.setState(
      {
        isSubMenuVisible: false,
      },
      () => {
        const duration = 250;
        setTimeout(() => {
          this.setState(
            {
              selectedSubMenu: null,
            },
            () => {
              this.props.onSelectSubMenu(null);
            },
          );
        }, duration);
      },
    );
  };

  renderCollapsible = (email, nav, id) => {
    if (id && nav) {
      const currentMenu = Header.getCurrentMenu(nav, id);
      const titleStyles = 'flex items-center no-underline bb bt-0 bl-0 br-0 b--light-gray pa3';
      const subTitleStyles = `${titleStyles} mid-gray bg-near-white b--dotted futura-heavy f8 ttu`;

      return (
        <div>
          {currentMenu
            ? Object.keys(currentMenu).map(menuItem => (
                <Collapsible
                  key={`mobile-menu-collapsible-${currentMenu[menuItem].label}`}
                  label={renderTitle(
                    {
                      label: currentMenu[menuItem].label,
                      secondaryLabel: currentMenu[menuItem]['secondary-label'],
                      entity: currentMenu[menuItem].entity,
                    },
                    false,
                    true,
                  )}
                  styles={titleStyles}
                >
                  <div>
                    {renderCollapsibleContent(
                      {
                        email,
                        list: currentMenu[menuItem].items,
                        styles: subTitleStyles,
                      },
                      this.closeMenu,
                    )}
                    {renderList(
                      {
                        email,
                        list: currentMenu[menuItem].items,
                        gutterSpacing: null,
                      },
                      true,
                      this.closeMenu,
                    )}
                  </div>
                </Collapsible>
              ))
            : null}
        </div>
      );
    }
    return null;
  };

  render() {
    const {
      currentNav,
      fenderConnectProfile,
      globalNavData,
      navItems,
      isTest,
      isVisible,
      titles,
    } = this.props;
    const getDivider = str => (
      <div className="bg-near-white pt4 pb2 ph3 bb b--black-10 ttu gray f8">{str}</div>
    );
    const linkColor = 'dark-gray';
    const linkStyle =
      'db relative link outline-0 no-underline bb pa3 bb bl-0 bt-0 br-0 b--black-10 ttu f7 truncate';
    const style = `${isTest ? '' : 'db dn-l'}`;
    const userEmail =
      fenderConnectProfile && fenderConnectProfile.email ? fenderConnectProfile.email : '';
    const trackEvent = label => ({
      eventType: 'Click Main Navigation',
      properties: {
        navigation_core: label,
        email: userEmail,
      },
    });

    return (
      <OffCanvas isSubMenuVisible={this.state.isSubMenuVisible} isVisible={isVisible}>
        <div className={`mobile-menu ${style}`}>
          {renderHeader(titles.site, false, null, this.closeMenu)}
          <ul className="list ma0 pa0">
            {navItems && Array.isArray(navItems)
              ? navItems.map(navItem => (
                  <li
                    key={`mobile-menu-nav-item-${navItem.label}`}
                    data-id={`mobile-menu-nav-item-${navItem.label}`}
                  >
                    {navItem.items || !navItem.url || Header.isHash(navItem.url) ? (
                      <a
                        className={`${linkStyle} ${linkColor}`}
                        href={Header.isHash(navItem.url) ? navItem.url : ''}
                        onClick={event => {
                          event.preventDefault();
                          if (navItem.items) {
                            this.selectSubMenu(navItem.id);
                          }
                          if (!navItem.items && !navItems.url) {
                            this.handleClick(navItem.url);
                          }
                        }}
                      >
                        <span className={`${navItem['class-names']}`}>{navItem.label}</span>
                        {navItem.items ? (
                          <span
                            className={`${navItem['class-names']} absolute right-0 pr3 f4`}
                            style={{ top: '0.75rem' }}
                          >
                            <i className="icon-pointer-right-light" />
                          </span>
                        ) : null}
                      </a>
                    ) : (
                      <Link
                        className={`${linkStyle} ${linkColor}`}
                        onClick={navItem.target ? null : this.closeMenu}
                        target={navItem.target ? navItem.target : ''}
                        to={!navItem.url ? '' : navItem.url}
                        trackEvent={trackEvent(navItem.label)}
                        dataId={`mobile-menu-nav-item-${navItem.label}`}
                      >
                        <span className={`${navItem['class-names']}`}>{navItem.label}</span>
                      </Link>
                    )}
                  </li>
                ))
              : null}
            {getDivider(titles.connect)}
            {this.props.fenderConnect}
          </ul>
          {getDivider(titles.apps)}
          <ul className="list ma0 pa0" data-id="mobile-menu-global-nav">
            {Object.keys(globalNavData).map(key =>
              key === currentNav ? (
                <li
                  key={`mobile-menu-global-nav-${key}`}
                  data-id={`mobile-menu-global-nav-${key}`}
                  className={`bl bw2 b--${globalNavData[key].color}`}
                >
                  <span className={`${linkStyle} ${globalNavData[key].color}`}>
                    {globalNavData[key].title}
                  </span>
                </li>
              ) : (
                <li key={`mobile-menu-global-nav-${key}`} data-id={`mobile-menu-global-nav-${key}`}>
                  <Link
                    className={`${linkStyle} ${linkColor}`}
                    to={globalNavData[key].url}
                    trackEvent={trackEvent(globalNavData[key].title)}
                  >
                    {globalNavData[key].title}
                  </Link>
                </li>
              ),
            )}
          </ul>
          <OffCanvas isVisible={this.state.isSubMenuVisible}>
            {Array.isArray(navItems) && navItems && this.state.selectedSubMenu ? (
              <div>
                {renderHeader(this.state.selectedSubMenu, true, this.closeSubMenu, this.closeMenu)}
                {this.renderCollapsible(userEmail, navItems, this.state.selectedSubMenu)}
              </div>
            ) : null}
          </OffCanvas>
        </div>
      </OffCanvas>
    );
  }
}

MobileMenu.propTypes = {
  currentNav: PropTypes.string,
  fenderConnect: PropTypes.element.isRequired,
  fenderConnectProfile: PropTypes.shape({
    email: PropTypes.string,
  }),
  globalNavData: PropTypes.shape({}).isRequired,
  isTest: PropTypes.bool,
  isVisible: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  onCloseMenu: PropTypes.func.isRequired,
  onSelectSubMenu: PropTypes.func.isRequired,
  navItems: PropTypes.arrayOf(PropTypes.shape({})),
  selectedSubMenu: PropTypes.string,
  titles: PropTypes.shape({
    site: PropTypes.string,
    connect: PropTypes.string,
    apps: PropTypes.string,
  }),
};

MobileMenu.defaultProps = {
  currentNav: '',
  fenderConnectProfile: null,
  isTest: false,
  isVisible: null,
  navItems: [],
  selectedSubMenu: null,
  titles: {
    site: 'Fender',
    connect: 'Fender Connect',
    apps: 'Fender Apps',
  },
};

export default MobileMenu;
